import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaEnvelope } from "react-icons/fa";
import api from "../api";
import { theme } from "../theme";

const logo = "/metria-logo.svg";

const EsqueciSenha = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.erro || "Falha ao processar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src={logo} alt="Metria" style={styles.logo} />
        <h2 style={styles.title}>Esqueceu sua senha?</h2>

        {sent ? (
          <>
            <p style={styles.desc}>
              Se houver uma conta com esse email, voce vai receber em instantes um link
              para criar uma nova senha. O link e valido por <strong>1 hora</strong>.
            </p>
            <p style={{ ...styles.desc, marginTop: 16, fontSize: 13 }}>
              Nao recebeu? Verifique a caixa de spam ou tente outro email.
            </p>
            <Link to="/login" style={{ ...styles.link, display: 'block', marginTop: 24 }}>
              Voltar para o login
            </Link>
          </>
        ) : (
          <>
            <p style={styles.desc}>
              Digite o email da sua conta. A gente envia um link para voce redefinir a senha.
            </p>
            <form onSubmit={handleSubmit} style={{ marginTop: 24 }}>
              <div style={styles.inputWrap}>
                <FaEnvelope style={styles.inputIcon} />
                <input
                  type="email"
                  required
                  placeholder="email@exemplo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={styles.input}
                  autoFocus
                />
              </div>
              {error && <div style={styles.error}>{error}</div>}
              <button
                type="submit"
                disabled={loading}
                style={{ ...styles.btnPrimary, opacity: loading ? 0.6 : 1, marginTop: 16 }}
              >
                {loading ? "Enviando..." : "Enviar link"}
              </button>
            </form>
            <p style={{ ...styles.desc, marginTop: 24, fontSize: 13, textAlign: 'center' }}>
              <Link to="/login" style={styles.link}>Voltar para o login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: theme.colors.bg, padding: 16,
  },
  card: {
    background: '#fff', padding: 32, borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
    maxWidth: 420, width: '100%',
  },
  logo: { display: 'block', margin: '0 auto 20px', height: 48 },
  title: {
    margin: '0 0 8px', fontSize: 22, fontWeight: 700,
    color: theme.colors.text, textAlign: 'center',
  },
  desc: {
    margin: 0, fontSize: 14, lineHeight: 1.6,
    color: theme.colors.textSecondary, textAlign: 'center',
  },
  inputWrap: {
    position: 'relative', marginTop: 12,
  },
  inputIcon: {
    position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
    color: theme.colors.textMuted, fontSize: 14,
  },
  input: {
    width: '100%', padding: '12px 14px 12px 40px',
    borderRadius: 10, border: `1px solid ${theme.colors.border}`,
    fontSize: 14, outline: 'none',
  },
  btnPrimary: {
    width: '100%', padding: '12px 16px', borderRadius: 10,
    border: 'none', background: theme.colors.primary, color: '#fff',
    fontWeight: 600, fontSize: 15, cursor: 'pointer',
  },
  link: {
    color: theme.colors.primary, textDecoration: 'none', fontWeight: 600,
  },
  error: {
    background: theme.colors.dangerLight || '#FEE',
    color: theme.colors.danger || '#B91C1C',
    padding: '10px 12px', borderRadius: 8,
    fontSize: 13, marginTop: 12,
  },
};

export default EsqueciSenha;
